import ActivityCategoryModel       from 'Models/sales/ActivityCategoryModel';
import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

@model.staticLabel('Activité')
@model.urnResource('operation_category')
@doc.path('/operation_categories/{?id}')
export default class OperationCategoryModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'operationTypes.operations.operationStatus': id;
		'operationTypes.operations.operationStatus.reference': InterventionOperationStatusReference;
		'operationTypes.operations.partitionUrn': Urn;
		'currentTechnicianHourlyCost': id;
		'currentTechnicianHourlyCost.resourceType': id;
		'currentTechnicianHourlyCost.resourceType.reference': InterventionResourceTypeReference;
		'id': id;
		'sourceUrn': Urn;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'position': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare label: string;
	@doc.number declare position: number;
	@doc.modelUrn(ActivityCategoryModel) declare source: ActivityCategoryModel;

	public get currentTechnicianHourlyCostId(): id | null {
		return this.get('currentTechnicianHourlyCost.id', null);
	}
}